import di from 'Services/di.js';

const handleOnClose = () => {
    setTimeout(() => {
        di.events.emit('tasks__formAddTask:closeFormAddTask');
    });
};

export default handleOnClose;
